import React, { useState, useEffect } from 'react';
import { formatCurrency, getAlert, parseCurrency, useEscapeClose } from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getRowStyle, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';
import { formatDate } from '../../../utils/DateUtils';
import DatePicker from '../DatePicker';
import moment from 'moment';

const RecModal = ({ showRecModal, handleRecClose, recDataList, onConfirmRecSelection }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filteredRecDataList, setFilteredRecDataList] = useState(recDataList);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [docStatusPaid, setDocStatusPaid] = useState(0);

    useEscapeClose(showRecModal, handleRecClose);

    useEffect(() => {
        setFilteredRecDataList(
            recDataList.filter(rec =>
                (rec.Rec_No.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    rec.AP_Name.toLowerCase().includes(searchTerm.toLowerCase())) &&
                (!startDate || !endDate || (moment(rec.Rec_Date).isBetween(startDate, endDate, 'day', '[]'))) &&
                rec.Doc_Status_Paid === docStatusPaid
            )
        );
    }, [searchTerm, startDate, endDate, docStatusPaid, recDataList]);

    useEffect(() => {
        if (showRecModal) {
            setSearchTerm('');
            setSelectedItems([]);
            setStartDate(moment(Math.min(...recDataList.map(rec => moment(rec.Rec_Date || moment())))));
            setEndDate(moment(Math.max(...recDataList.map(rec => moment(rec.Rec_Date || moment())))));
            setDocStatusPaid(0);
        }
    }, [showRecModal]);

    const checkApNameConsistency = (items) => {
        if (items.length > 0) {
            // เช็กเงื่อนไขเลือกผู้รับเงินเป็นรายเดียวกัน
            const apName = items[0].AP_Name;
            const isApNameConsistent = items.every(item => item.AP_Name === apName);
            if (!isApNameConsistent) {
                getAlert('FAILED', 'กรุณาเลือกผู้รับเงินเป็นรายเดียวกัน');
                return false;
            }

            // เช็กเงื่อนไขเลือกใบรับสินค้าที่มี VAT เหมือนกัน
            // const isVat = items[0].IsVat;
            // const isVatConsistent = items.every(item => item.IsVat === isVat);
            // if (!isVatConsistent) {
            //     getAlert('FAILED', 'กรุณาเลือกใบรับสินค้าที่มีสถานะ VAT เหมือนกัน โดยต้องเลือกทั้งหมดเป็น VAT หรือไม่มี VAT เท่านั้น');
            //     return false;
            // }

            return true;
        }

        return true;
    };


    const handleCheckboxChange = (rec) => {
        const updatedSelectedItems = selectedItems.some(item => item.Rec_No === rec.Rec_No)
            ? selectedItems.filter(item => item.Rec_No !== rec.Rec_No)
            : [...selectedItems, rec];

        setSelectedItems(updatedSelectedItems);
    };

    const handleConfirmSelection = () => {
        if (checkApNameConsistency(selectedItems)) {
            onConfirmRecSelection(selectedItems);
        }
    };

    const clearSelection = () => {
        setSelectedItems([]);
    };

    return (
        <>
            <div className={`modal ${showRecModal ? 'show' : ''}`} style={{ display: showRecModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อใบรับสินค้า</h5>
                            <button type="button" className="close" onClick={handleRecClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <span className="fw-bold">ค้นหาเอกสาร</span>
                                        <input
                                            style={{ width: '100%' }}
                                            type="text"
                                            className="form-control"
                                            placeholder="ค้นหาเลขที่เอกสาร (REC) หรือ ชื่อผู้ขาย"
                                            value={searchTerm || ''}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <span className="fw-bold">สถานะจ่าย</span>
                                        <div className="radio-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="docStatusPaid"
                                                value={0}
                                                id="status0"
                                                checked={docStatusPaid === 0}
                                                onChange={(e) => clearSelection() + setDocStatusPaid(parseCurrency(e.target.value))}
                                            />
                                            <label className="form-check-label ml-2" htmlFor="status0">ยังไม่ทำรายการ</label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="docStatusPaid"
                                                value={1}
                                                id="status1"
                                                checked={docStatusPaid === 1}
                                                onChange={(e) => clearSelection() + setDocStatusPaid(parseCurrency(e.target.value))}
                                            />
                                            <label className="form-check-label ml-2" htmlFor="status1">ค้างจ่าย</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <span className="fw-bold">วันที่เริ่มต้น</span>
                                    <DatePicker
                                        label=""
                                        name="startDate"
                                        value={startDate}
                                        onChange={(date) => setStartDate(moment(date).format('YYYY-MM-DD'))}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-3">
                                    <span className="fw-bold">วันที่สิ้นสุด</span>
                                    <DatePicker
                                        label=""
                                        name="endDate"
                                        value={endDate}
                                        onChange={(date) => setEndDate(moment(date).format('YYYY-MM-DD'))}
                                        disabled={false}
                                    />
                                </div>
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '1%' }}>
                                                <input type="checkbox" onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setSelectedItems(checked ? filteredRecDataList : []);
                                                }} checked={filteredRecDataList.length > 0 && selectedItems.length === filteredRecDataList.length} />
                                            </th>
                                            <th className="text-center" style={{ width: '15%' }}>เลขที่เอกสาร (REC)</th>
                                            <th className="text-center" style={{ width: '30%' }}>ชื่อผู้ขาย</th>
                                            <th className="text-center" style={{ width: '25%' }}>รายละเอียดเอกสาร</th>
                                            <th className="text-center" style={{ width: '10%' }}>วันที่รับเข้า</th>
                                            <th className="text-center" style={{ width: '7%' }}>ราคารวม</th>
                                            <th className="text-center" style={{ width: '12%' }}>สถานะจ่าย</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredRecDataList && filteredRecDataList.length > 0 ? (
                                            filteredRecDataList.map((rec, index) => (
                                                <tr
                                                    key={rec.Rec_Id || index + 1}
                                                    checked={selectedItems.some(item => item.Rec_No === rec.Rec_No)}
                                                    onClick={() => {
                                                        setSelectedRowIndex(index);
                                                        handleCheckboxChange(rec);
                                                    }}
                                                    style={getRowStyle(index, selectedRowIndex)}

                                                >
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedItems.some(item => item.Rec_No === rec.Rec_No)}
                                                            onChange={() => handleCheckboxChange(rec)}
                                                            style={getRowStyle(index, selectedRowIndex)}
                                                        />
                                                    </td>
                                                    <td className="text-center">{rec.Rec_No}</td>
                                                    <td className="text-left">{rec.AP_Name}</td>
                                                    <td className="text-left">{rec.Doc_Remark1}</td>
                                                    <td className="text-center">{formatDate(rec.Rec_Date)}</td>
                                                    <td className="text-end">{formatCurrency(rec.NetTotal)}</td>
                                                    <td className="text-center">{rec.DocStatusPaid_Name}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-success" onClick={handleConfirmSelection}>
                                ยืนยันการเลือก
                            </button>
                            <button className="btn btn-warning" onClick={clearSelection}>
                                ยกเลิกการเลือก
                            </button>
                            <button className="btn btn-danger" onClick={handleRecClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecModal;